import { z } from 'zod';

export const TSDRevokePresentationNotificationSchema = z.object({
  tsdId: z.string().min(1, { message: 'Required' }),
  revocationReason: z.string().max(512).optional(),
});

export type TSDRevokePresentationNotificationData = z.infer<typeof TSDRevokePresentationNotificationSchema>;
